import { useEffect, useState, useContext } from 'react'
import * as Sentry from "@sentry/react"
import _ from 'lodash'

import { ProductSelectContext } from "../../../store/ProductSelectContext"
import { StorefrontContext } from "../../../store/StorefrontContext"
import { PaymentContext } from "../../../store/PaymentContext"

import Octopus from "../../../api/payment/octopus"
import octopusErrors from "./octopus_errors.json"
import Spinner from 'react-bootstrap/Spinner';

// import octopusErrors from "./octopus_errors.json"

const OctopusPaymentDetails = () => {
    let isMounted = true;

    const { state: paymentState, dispatch: paymentDispatch } = useContext(PaymentContext);
    const { productSelected, setProductSelected } = useContext(ProductSelectContext);

    const [paymentRetryCount, setPaymentRetryCount] = useState(0);
    const [paymentMessage, setPaymentMessage] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const [initDone, setInitDone] = useState(false);

    const config = {
        paymentType: '',
        pollData: {},
        deductStatus: {},
        extraInfoData: {},
        transactionId: Math.floor(Math.random() * 1000000),
        localAmount: 0,
        transactionDateTime: '',
        startedRetryLoop: false,
        retryLoopInterval: 0,  // init timer  
        incompleteTransactionCardNumber: null,
    }

    const octopusSettings = {
        max_poll_unpresent_card_retry: 9,
        error: {
            failed_to_connect_rwl: 100001,
            incomplete_transaction: 100022,
            transaction_log_full: 100023,
            authentication_fail: 100029,
            unpresent_card: 100032,
            insufficient_fund: 100048,
            others: 'others',
        },
        notifiable_errors: [100001, 100002, 100003, 100005, 100050, 100051, 100066],
    };

    useEffect(() => {
        console.log('initDone', initDone)
        if (initDone || !isMounted) {
            return
        }
        setPaymentMessage('Connecting to octopus device')
        // initcomm to check if octopus is connected
        Octopus.initComm().then((data) => {
            console.log('initcomm', data)
            setInitDone(true)
            setShowLoading(false)
            setPaymentMessage('Connect to octopus device successfully')
            console.log('Octopus connected')

        }).catch((error) => {
            console.error('Octopus not connected', error);
            setPaymentMessage('Failed to connect to octopus device')
            Sentry.captureException(error);
            setTimeout(() => {
                // cancelPayment()
                paymentDispatch({
                    type: 'reset'
                })
            }, 3000)
        })
    }, [initDone])

    useEffect(() => {
        return () => {
            isMounted = false; // Cleanup when the component unmounts
        }
    }, [])

    useEffect(() => {
        if (paymentState.paymentStatus === 'received') {
            setTimeout(() => {
                paymentDispatch({
                    type: 'update',
                    payload: {
                        paymentStatus: 'success'
                    }
                })
            }, 3000)
        }
    }, [paymentState.paymentStatus])

    useEffect(() => {
        console.log('useEffect paymentRetryCount, productSelected', paymentRetryCount, productSelected);
        if (!initDone) {
            return
        }
        if (paymentRetryCount < octopusSettings.max_poll_unpresent_card_retry && productSelected) {
            console.log('useEffect fetchOctopusPayResponse', productSelected);
            fetchOctopusPayResponse();
        } else {
            console.log('useEffect fetchOctopusPayResponse reset');
            paymentDispatch({
                type: 'reset'
            })
        }
    }, [initDone, paymentRetryCount])

    const getLastAddValueObject = (lastAddValue) => {
        let parts = lastAddValue.split(',')
        if (!['1', '2', '4'].includes(parts[1].toString())) {
            return null
        }

        return {
            date: parts[0],
            type: getLastAddValueTypeText(parts[1]),

            deviceId: parts[2],
        }
    }

    const getLastAddValueTypeText = (type) => {
        switch (type.toString()) {
            case '1':
                return 'cash'
            case '2':
                return 'online'
            case '4':
                return 'aavs'
            default:
                return 'other'
        }
    }

    const deductOctopusCardBalance = (deductInfo) => {
        Octopus.deduct(deductInfo).then((deductStatus) => {
            config.deductStatus = deductStatus
            console.log('deductStatus', deductStatus)
            return Octopus.getExtraInfo()
        }).then((extraInfoData) => {
            console.log(`
                Deduct octopus card balance success: ${deductInfo.amount}<br/>
                Transaction ID: ${config.transactionId}<br/>
                Balance Amount: ${config.deductStatus / 10}<br/>
                Card Number: ${config.pollData.cardNumber}<br/>
                Customer Info: ${_.split(config.pollData.customerInfo, '-')}
                Last Add Value: ${getLastAddValueObject(extraInfoData)}
            `)
            setPaymentMessage(null)
            paymentDispatch({
                type: 'update',
                payload: {
                    paymentStatus: 'received',
                    paymentStatusDesc: 'Payment Received',
                    paymentId: config.transactionId,
                    paymentGatewayDetails: extraInfoData,
                    currencyCode: productSelected.currencyCode,
                    lastAddValue: getLastAddValueObject(extraInfoData),
                    localAmount: deductInfo.amount,
                    transactionId: config.transactionId,
                    balanceAmount: config.deductStatus / 10,
                    cardNumber: config.pollData.cardNumber,
                    customerInfo: _.split(config.pollData.customerInfo, '-')
                }
            })

        }).catch((error) => {
            Sentry.captureException(error);
            console.log('deduct error', error)
            console.error('deductOctopusCardBalance error', error);
            switch (error.error) {
                case octopusSettings.error.incomplete_transaction:
                    deductOctopusCardBalance(deductInfo)
                    break
                case octopusSettings.error.insufficient_fund:
                    setPaymentMessage('Insufficient fund')
                    setTimeout(() => {
                        // cancelPayment()
                        paymentDispatch({
                            type: 'reset'
                        })
                    }, 5000)
                    break
                default:
                    setPaymentMessage('Error occurred, please try again')
                    setPaymentRetryCount(0)
                    break
            }
        })
    }
    const fetchOctopusPayResponse = () => {
        if (!isMounted) {
            console.log('return due to unmount')
            return
        }; // Prevent further execution if the component is unmounted
        setPaymentMessage('Please present your Octopus card')

        Octopus.poll().then(({ pollData }) => {
            config.pollData = pollData
            console.log('pollData', pollData)
            deductOctopusCardBalance({
                amount: productSelected.price,
                transactionId: config.transactionId,
                cardNumber: pollData.cardNumber,
            })
            return
        }).catch((error) => {
            Sentry.captureException(error);
            console.log('poll error', error)
            if (error.error === octopusSettings.error.unpresent_card) {
                console.log('paymentRetryCount', `${paymentRetryCount}/${octopusSettings.max_poll_unpresent_card_retry}`)
                setPaymentMessage('Please present your Octopus card')
            }
            // TODO: check octopus_errors.json to set error message and see if need to retry

            if (error.type === 'userCancel') {
                console.error(error.message)
                return
            }
            console.log('paymentRetryCount add')
            setPaymentRetryCount((prevCount) => prevCount + 1)
        })
    }

    return (
        <div className="octopus-payment-details">
            {paymentMessage &&
                <div className="payment-message">
                    {paymentMessage}
                </div>
            }
            {showLoading &&
                <div className="loading">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            }
            {
                paymentState.paymentStatus === 'received' &&
                <>
                    <h5>Payment Result</h5>
                    <div className="payment-result">
                        <div className="deduct-balance">
                            <label>Payment Amount:</label>
                            <span>{paymentState.localAmount}</span>
                        </div>
                        <div className="card-number">
                            <label>Card Number:</label>
                            <span>{paymentState.cardNumber}</span>
                        </div>
                        <div className="balance-amount">
                            <label>Balance Amount:</label>
                            <span>{paymentState.balanceAmount}</span>
                        </div>
                        <div className="customer-info">
                            <label>Customer Info:</label>
                            <span>{paymentState.customerInfo}</span>
                        </div>
                        <div className="transaction-id">
                            <label>Transaction ID:</label>
                            <span>{paymentState.transactionId}</span>
                        </div>
                    </div>
                </>
            }
        </div>
    );
}

export default Sentry.withProfiler(OctopusPaymentDetails);